"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");

var SelloutImpactRecord_1 = require("./SelloutImpactRecord");
/**
 * Contains available supply related fields of `SelloutImpactRecord`. It is used in `CommonReleaseOverview`.
 * When fetching from DB it is expected to return something like Map<releaseId, SelloutImpactRecordStockValues>.
 *
 * @author Jan Prokop
 */


var SelloutImpactRecordStockValues =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactRecordStockValues, _DomainObject_1$Domai);

  function SelloutImpactRecordStockValues(releaseId, availableSupplyPrice, availableSupply, availableSupplyBeforeRepricingPrice, availableSupplyBeforeRepricing, availableSupplyPriceChange, availableSupplyChange, availableSupplyPriceChangePercent, availableSupplyChangePercent) {
    var _this;

    _classCallCheck(this, SelloutImpactRecordStockValues);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactRecordStockValues).call(this));
    _this.releaseId = releaseId;
    _this.availableSupplyPrice = availableSupplyPrice;
    _this.availableSupply = availableSupply;
    _this.availableSupplyBeforeRepricingPrice = availableSupplyBeforeRepricingPrice;
    _this.availableSupplyBeforeRepricing = availableSupplyBeforeRepricing;
    _this.availableSupplyPriceChange = availableSupplyPriceChange;
    _this.availableSupplyChange = availableSupplyChange;
    _this.availableSupplyPriceChangePercent = availableSupplyPriceChangePercent;
    _this.availableSupplyChangePercent = availableSupplyChangePercent;
    return _this;
  }
  /**
   * You can use this to extract data from SelloutImpactRecord.
   *
   * @param mat
   */


  _createClass(SelloutImpactRecordStockValues, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutImpactRecordStockValues(mat.releaseId, mat.availableSupplyPrice, mat.availableSupply, mat.availableSupplyBeforeRepricingPrice, mat.availableSupplyBeforeRepricing, mat.availableSupplyPriceChange, mat.availableSupplyChange, mat.availableSupplyPriceChangePercent, mat.availableSupplyChangePercent);
    }
  }]);

  return SelloutImpactRecordStockValues;
}(DomainObject_1.DomainObject);

exports.SelloutImpactRecordStockValues = SelloutImpactRecordStockValues;
SelloutImpactRecordStockValues.schema = {
  releaseId: SelloutImpactRecord_1.SelloutImpactRecord.schema.releaseId,
  availableSupplyPrice: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupplyPrice,
  availableSupply: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupply,
  availableSupplyBeforeRepricingPrice: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupplyBeforeRepricingPrice,
  availableSupplyBeforeRepricing: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupplyBeforeRepricing,
  availableSupplyPriceChange: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupplyPriceChange,
  availableSupplyChange: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupplyChange,
  availableSupplyPriceChangePercent: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupplyPriceChangePercent,
  availableSupplyChangePercent: SelloutImpactRecord_1.SelloutImpactRecord.schema.availableSupplyChangePercent
};